var S = (H, M, _) => new Promise((U, k) => {
  var b = (u) => {
    try {
      T(_.next(u));
    } catch (w) {
      k(w);
    }
  }, r = (u) => {
    try {
      T(_.throw(u));
    } catch (w) {
      k(w);
    }
  }, T = (u) => u.done ? U(u.value) : Promise.resolve(u.value).then(b, r);
  T((_ = _.apply(H, M)).next());
});
import "../../node_modules/.pnpm/vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { OssUpload as pe } from "@oppein-lib/op-upload";
import { getOssUrl as R, opBatchDownloadFiles as we, selfAxios as z, opDownloadFile as ye } from "@oppein/op-utils";
import ge from "../file-preview/filePreview.ce.vue.js";
import Q from "../../com-components/file-upload/util/baseUrl.js";
import { NIcon as W } from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/icon/src/Icon.js";
import { defineComponent as he, useTemplateRef as Y, openBlock as x, createElementBlock as A, createElementVNode as p, createVNode as l, withCtx as n, createTextVNode as g, Fragment as ee, renderList as _e, createCommentVNode as $, createBlock as be } from "../../node_modules/.pnpm/@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { useShadowRoot as Ce } from "../../node_modules/.pnpm/@vue_runtime-dom@3.5.18/node_modules/@vue/runtime-dom/dist/runtime-dom.esm-bundler.js";
import { useMessage as xe } from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/message/src/use-message.js";
import { useDialog as ke } from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/dialog/src/composables.js";
import { ref as s, unref as i } from "../../node_modules/.pnpm/@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
import Te from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/card/src/Card.js";
import h from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/button/src/Button.js";
import te from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/select/src/Select.js";
import Ne from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/upload/src/Upload.js";
import Se from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/spin/src/Spin.js";
import Ae from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/modal/src/Modal.js";
import { toDisplayString as De } from "../../node_modules/.pnpm/@vue_shared@3.5.18/node_modules/@vue/shared/dist/shared.esm-bundler.js";
const ze = {
  class: "tw:py-2.5"
}, Me = {
  class: "tw:flex tw:items-center tw:gap-4 tw:mb-5"
}, Ue = {
  class: "tw:max-h-[300px] tw:overflow-y-auto"
}, Oe = {
  class: "tw:flex tw:justify-between tw:items-center"
}, Pe = {
  class: "tw:flex tw:items-center tw:flex-1 tw:overflow-hidden"
}, Be = ["title"], Fe = {
  class: "tw:flex tw:items-center tw:whitespace-nowrap tw:gap-3 tw:ml-2"
}, Ve = {
  key: 0,
  class: "tw:text-center tw:text-gray-400 tw:py-5"
}, Ie = {
  key: 0,
  class: "tw:mt-5"
}, Re = {
  class: "tw:flex tw:justify-end tw:gap-3"
}, ot = /* @__PURE__ */ he({
  __name: "uploadFileDialog.ce",
  setup(H, {
    expose: M
  }) {
    const _ = {
      name: "UploadIcon",
      render() {
        return l("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 1024 1024",
          width: "1em",
          height: "1em"
        }, [l("path", {
          fill: "currentColor",
          d: "M544 864V416a32 32 0 0 0-64 0v448a32 32 0 0 0 64 0zm-224-64V416a32 32 0 0 0-64 0v384a32 32 0 0 0 64 0zm448 0V416a32 32 0 0 0-64 0v384a32 32 0 0 0 64 0zM640 192H384a32 32 0 0 1 0-64h256a32 32 0 0 1 0 64z"
        }, null), l("path", {
          fill: "currentColor",
          d: "M512 64L320 256h384L512 64z"
        }, null)]);
      }
    }, U = {
      name: "DocumentIcon",
      render() {
        return l("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 1024 1024",
          width: "1em",
          height: "1em"
        }, [l("path", {
          fill: "currentColor",
          d: "M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-40 824H232V136h560v752z"
        }, null), l("path", {
          fill: "currentColor",
          d: "M320 184h384v64H320zm0 128h384v64H320zm0 128h384v64H320zm0 128h256v64H320z"
        }, null)]);
      }
    };
    Ce();
    const k = Y("dialogContainer"), b = Y("filePreviewRef"), r = xe(), T = ke(), u = s(!1), w = s(!1), d = s([]), m = s(""), K = s(null), D = s(5), X = s("附件上传"), O = s(""), P = s([]), j = s("MTDS"), E = s("MTDSPC001"), L = s("MTDS"), y = s(!1), J = s(!1), B = s(""), F = s(""), Z = s(!1), ae = s(""), N = s(""), V = s([]), I = s(!1);
    let f = null;
    const le = () => {
      const e = z.defaults.baseURL;
      return e != null && e.includes("apigatewaysit") ? "sit" : e != null && e.includes("apigatewayuat") ? "uat" : e != null && e.includes("apigatewayver") ? "ver" : (e != null && e.includes("apigateway.oppein"), "pro");
    }, se = () => {
      const e = le();
      Q.init(e);
      const t = Q.getBaseUrl().apigateway, a = z.defaults.headers.common["Oauth2-AccessToken"] || "";
      K.value = new pe({
        appCode: j.value,
        subAppCode: E.value,
        baseURL: t,
        token: a
      });
    }, oe = (e = {}) => (D.value = e.limit || 5, X.value = e.title || "附件上传", O.value = e.businessType || "", P.value = e.attachmentTypeOptions || [], d.value = JSON.parse(JSON.stringify(e.fileList || [])), m.value = "", j.value = e.appCode || "MTDS", E.value = e.subAppCode || "MTDSPC001", L.value = e.sysPlatform || "MTDS", y.value = e.disabled || !1, J.value = e.allowXml || !1, B.value = e.category || "", F.value = e.specialChar || "", Z.value = e.isShowTableRemark || !1, ae.value = e.defaultTableRemark || "", N.value = e.defaultTableRemark || "", u.value = !0, se(), B.value === "category_chugui" ? me() : V.value = [], new Promise((t) => {
      f = t;
    })), re = (e) => {
      if (!m.value)
        return r.error("请先选择附件类型!"), !1;
      if (e.name.includes("台面") && m.value !== "hasTableAttachment")
        return r.warning('当前上传的文件命名中含有"台面"字样，如需上传台面文件请选择"台面附件"类型上传（卫浴台面图通过CAXA生成，不允许自行上传）。'), !1;
      const a = e.name.split(".")[e.name.split(".").length - 1], o = e.name.lastIndexOf(`.${a}`), c = e.name.substring(0, o), v = [];
      if (F.value && F.value.split(",").forEach((C) => {
        c.includes(C) && v.push(C);
      }), v.length > 0) {
        const C = `上传附件文件名包含非法字符（${v.join("和")}），请修正文件名重传`;
        return r.error(C), !1;
      }
      return !e.name.includes(".") || !/^[a-zA-Z]+$/.test(a) ? (r.warning("上传的文件没有后缀名，不符合上传规范，请修改后再上传"), !1) : a === "xml" && !J.value ? (r.warning("一键下单不允许用户自行上传xml文件"), !1) : (m.value === "价格附件" || m.value === "其他附件") && e.name.includes("台面") ? (r.warning('当前上传的文件命名中含有"台面"字样，如需上传台面文件请选择"台面附件"类型上传（卫浴台面图通过CAXA生成，不允许自行上传）。'), !1) : !0;
    }, ne = (e) => S(this, null, function* () {
      var a;
      const t = e.file.file;
      if (t && re(t)) {
        if (d.value.length >= D.value) {
          r.warning(`当前限制选择 ${D.value} 个文件`);
          return;
        }
        try {
          w.value = !0;
          const o = yield (a = K.value) == null ? void 0 : a.uploadFile({
            file: t
          }, {
            sysPlatform: L.value,
            businessType: O.value
          }, 0);
          if (console.log("UploadFile res", o), o) {
            const c = P.value.find((ve) => ve.code === m.value), C = {
              fileName: (c == null ? void 0 : c.name) + "-" + o.filename,
              ossKey: o.name,
              filePath: o.name,
              size: o.size,
              suffix: o.suffix,
              uploadDt: (/* @__PURE__ */ new Date()).getTime(),
              remark: m.value,
              businessType: O.value
            };
            d.value = [...d.value, C];
          }
        } catch (o) {
          console.error("上传失败:", o), r.error("文件上传失败");
        } finally {
          w.value = !1;
        }
      }
    }), ie = (e) => S(this, null, function* () {
      var a, o, c;
      if (!(e.type && (e.type === "11" || e.type === "12")))
        (a = b.value) == null || a.open({
          fileUrl: R({
            url: e.ossKey
          })
        });
      else if (e.type === "12")
        try {
          const {
            data: v
          } = yield z.get("/designordercenterapi/order/attachment/getPrivateSignedUrl", {
            params: {
              ossKey: e.ossKey
            }
          });
          v.status ? (o = b.value) == null || o.open({
            fileUrl: v.data
          }) : r.error("获取预览链接失败，请重试");
        } catch (v) {
          console.error(v), r.error("获取预览链接失败，请重试");
        }
      else
        (c = b.value) == null || c.open({
          fileUrl: e.ossKey + ".url"
        });
    }), ue = (e) => {
      ye(R({
        url: e.ossKey
      }), e.fileName);
    }, de = () => S(this, null, function* () {
      if (d.value.length === 0) {
        r.warning("没有可下载的文件");
        return;
      }
      const e = d.value.filter((t) => !(t.type && (t.type === "11" || t.type === "12")));
      if (e.length === 0) {
        r.warning("没有可下载的文件");
        return;
      }
      try {
        I.value = !0;
        const t = e.map((o) => ({
          fileName: o.fileName,
          url: R({
            url: o.ossKey
          })
        })), a = yield we(t);
        a.status || r.error(a.message || "批量下载失败");
      } catch (t) {
        console.error(t), r.error("批量下载失败，请重试");
      } finally {
        I.value = !1;
      }
    }), ce = (e) => {
      y.value || T.warning({
        title: "提示",
        content: "确认删除该文件吗？",
        positiveText: "确定",
        negativeText: "取消",
        onPositiveClick: () => {
          d.value.splice(e, 1), r.success("删除成功");
        }
      });
    }, me = () => S(this, null, function* () {
      try {
        const {
          data: e
        } = yield z.get("/mtdsbase/internal/dict/getDictCacheChildrenListByType", {
          params: {
            dictType: "ROOT_MTDS_not_use_caxa_json_reason"
          }
        });
        e.status && Array.isArray(e.data) && (V.value = e.data);
      } catch (e) {
        console.error(e);
      }
    }), q = () => B.value === "category_chugui" && d.value.some((e) => e.remark === "hasTableAttachment") && Z.value, G = () => {
      u.value = !1, f == null || f(null), f = null;
    }, fe = () => {
      if (q() && !N.value) {
        r.error("请选择不使用CAXA台面图的原因");
        return;
      }
      u.value = !1, f == null || f({
        fileList: d.value,
        tableRemark: N.value
      }), f = null;
    };
    return M({
      open: oe
    }), (e, t) => (x(), A(ee, null, [p("div", {
      ref_key: "dialogContainer",
      ref: k
    }, null, 512), l(i(Ae), {
      show: u.value,
      "onUpdate:show": t[2] || (t[2] = (a) => u.value = a),
      "mask-closable": !1,
      to: k.value || "body"
    }, {
      default: n(() => [l(i(Te), {
        title: X.value,
        style: {
          width: "650px"
        },
        bordered: !1,
        role: "dialog",
        closable: "",
        "on-close": G
      }, {
        footer: n(() => [p("div", Re, [l(i(h), {
          onClick: G
        }, {
          default: n(() => t[8] || (t[8] = [g("取 消", -1)])),
          _: 1,
          __: [8]
        }), l(i(h), {
          type: "primary",
          disabled: y.value,
          onClick: fe
        }, {
          default: n(() => t[9] || (t[9] = [g("确 定", -1)])),
          _: 1,
          __: [9]
        }, 8, ["disabled"])])]),
        default: n(() => [p("div", ze, [p("div", Me, [l(i(te), {
          value: m.value,
          "onUpdate:value": t[0] || (t[0] = (a) => m.value = a),
          options: P.value.map((a) => ({
            label: a.name,
            value: a.code
          })),
          placeholder: "请选择附件类型",
          size: "small",
          style: {
            width: "200px"
          },
          disabled: y.value
        }, null, 8, ["value", "options", "disabled"]), l(i(Ne), {
          action: "",
          "default-upload": !1,
          "show-file-list": !1,
          multiple: "",
          max: D.value,
          onChange: ne
        }, {
          default: n(() => [l(i(h), {
            type: "primary",
            size: "small",
            disabled: !m.value || y.value
          }, {
            icon: n(() => [l(i(W), null, {
              default: n(() => [l(_)]),
              _: 1
            })]),
            default: n(() => [t[3] || (t[3] = g(" 上传文件 ", -1))]),
            _: 1,
            __: [3]
          }, 8, ["disabled"])]),
          _: 1
        }, 8, ["max"]), l(i(h), {
          text: "",
          size: "small",
          loading: I.value,
          disabled: d.value.length <= 0,
          onClick: de
        }, {
          default: n(() => t[4] || (t[4] = [g(" 批量下载 ", -1)])),
          _: 1,
          __: [4]
        }, 8, ["loading", "disabled"])]), l(i(Se), {
          show: w.value
        }, {
          default: n(() => [p("div", Ue, [(x(!0), A(ee, null, _e(d.value, (a, o) => (x(), A("div", {
            key: o,
            class: "tw:px-2.5 tw:py-2 tw:border-b tw:border-gray-200"
          }, [p("div", Oe, [p("div", Pe, [l(i(W), {
            size: "18"
          }, {
            default: n(() => [l(U)]),
            _: 1
          }), p("span", {
            class: "tw:ml-2 tw:overflow-hidden tw:text-ellipsis tw:whitespace-nowrap",
            title: a.fileName
          }, De(a.fileName), 9, Be)]), p("div", Fe, [l(i(h), {
            text: "",
            onClick: (c) => ie(a)
          }, {
            default: n(() => t[5] || (t[5] = [g("预览", -1)])),
            _: 2,
            __: [5]
          }, 1032, ["onClick"]), a.type !== "11" && a.type !== "12" ? (x(), be(i(h), {
            key: 0,
            text: "",
            onClick: (c) => ue(a)
          }, {
            default: n(() => t[6] || (t[6] = [g("下载", -1)])),
            _: 2,
            __: [6]
          }, 1032, ["onClick"])) : $("", !0), l(i(h), {
            text: "",
            type: "error",
            disabled: y.value,
            onClick: (c) => ce(o)
          }, {
            default: n(() => t[7] || (t[7] = [g("删除", -1)])),
            _: 2,
            __: [7]
          }, 1032, ["disabled", "onClick"])])])]))), 128)), d.value.length === 0 ? (x(), A("div", Ve, "暂无文件")) : $("", !0)])]),
          _: 1
        }, 8, ["show"]), q() ? (x(), A("div", Ie, [l(i(te), {
          value: N.value,
          "onUpdate:value": t[1] || (t[1] = (a) => N.value = a),
          options: V.value,
          placeholder: "请选择不使用CAXA台面图的原因",
          size: "small",
          disabled: y.value
        }, null, 8, ["value", "options", "disabled"])])) : $("", !0), l(ge, {
          ref_key: "filePreviewRef",
          ref: b
        }, null, 512)])]),
        _: 1
      }, 8, ["title"])]),
      _: 1
    }, 8, ["show", "to"])], 64));
  }
});
export {
  ot as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/upload-file-dialog/uploadFileDialog.ce.vue.js
// module id = 1335
// module chunks = 67